import { useAsyncFetcher } from 'reporting-data/asyncData/useAsyncFetcher';
import { useCallback } from 'react';
// @ts-expect-error untyped module
import getProperties from 'reporting-data/properties';
import { getDataType } from 'reporting-data/report/configReportGetters';
import { isConfigReport } from 'reporting-data/tsTypes/reportTypes';
export function useSingleObjectReportPropertiesMap(report) {
  const dataType = isConfigReport(report) ? getDataType(report) : undefined;
  const fetcher = useCallback(() => getProperties(dataType), [dataType]);
  const resultFormatter = useCallback(response => {
    return response.get(dataType).toJS();
  }, [dataType]);
  return useAsyncFetcher({
    fetcher,
    resultFormatter
  });
}